import { defineStore } from 'pinia';

export const useViewerStore = defineStore('viewer', {
  state: () => ({
    fileLoaded: false,
    toggleLeft: false,
    toggleRight: false
  }),
  actions: {
    setFileLoadState(loaded: boolean) {
      this.fileLoaded = loaded;
    },
    setToggleLeftState(visible: boolean) {
      this.toggleLeft = visible
    },
    setToggleRightState(visible: boolean) {
      this.toggleRight = visible
    }
  },
  getters: {
    getFileLoadState(state): any {
      return state.fileLoaded
    },
    getToggleLeftState(state): any {
      return state.toggleLeft
    },
    getToggleRightState(state): any {
      return state.toggleRight
    }
  },
});